import { ActionKeys } from "../_actions/constants/adminConstants";
import toastr from "toastr";

const initialState = {
  isError: false,
  isSuccess: true,
  errorMessage: null,
  helpTexts: null,
  total: 0,
  fiscalYear: null,
  mailingAddress: null,
  chapterRanges: null,
  memberCounts: null,
  totalMemberCounts: 0,
  chapterList: null,
  reports: [],
  totalReports: 0,
  totalChapters: 0,
  activeChapter: null,
  chapterBudgets: null,
  activeChapterBudget: null,
  chapterFinancials: null,
  totalChapterFinancials: 0,
  chapterFinancialsDefaults: null,
  activeChapterFinancial: null,
  reportItemTypes: null,
  reportItemSubTypes: null,
  isFetching: {},
  isFetched: {},
  isUpdating: {}
};

export default function adminReducer(state, action) {
  state = state || initialState;
  const { isFetched, isFetching, isUpdating } = state;

  switch (action.type) {
    case ActionKeys.RESET_IS_FETCHED:
      state = {
        ...state,
        isFetched: {},
        activeChapterBudget: null,
        activeChapter: null
      };
      break;
    case ActionKeys.RESET_ACTIVE_CHAPTER_BUDGET:
      state = {
        ...state,
        activeChapterBudget: null
      };
      break;
    case ActionKeys.REQUEST_HELP_TEXT:
      state = {
        ...state,
        isError: false,
        isSuccess: true,
        isFetching: {
          ...isFetching,
          HELP_TEXT: true
        },
        isFetched: {
          ...isFetched,
          HELP_TEXT: false
        }
      };
      break;
    case ActionKeys.RECEIVE_HELP_TEXT:
      state = {
        ...state,
        ...action,
        isFetching: {
          ...isFetching,
          HELP_TEXT: false
        },
        isFetched: {
          ...isFetched,
          HELP_TEXT: true
        }
      };
      break;
    case ActionKeys.UPDATE_HELP_TEXT:
      state = {
        ...state,
        ...action
      };
      if (action.isSuccess) {
        toastr.success("Help text updated successfully");
      }
      break;
    case ActionKeys.REQUEST_FISCAL_YEAR:
      state = {
        ...state,
        isError: false,
        isSuccess: true,
        isFetching: {
          ...isFetching,
          FISCAL_YEAR: true
        },
        isFetched: {
          ...isFetched,
          FISCAL_YEAR: false
        }
      };
      break;
    case ActionKeys.RECEIVE_FISCAL_YEAR:
      state = {
        ...state,
        ...action,
        isFetching: {
          ...isFetching,
          FISCAL_YEAR: false
        },
        isFetched: {
          ...isFetched,
          FISCAL_YEAR: true
        }
      };
      break;
    case ActionKeys.UPDATE_FISCAL_YEAR:
      state = {
        ...state,
        ...action,
        isUpdating: {
          ...isUpdating,
          FISCAL_YEAR: true
        }
      };
      if (action.isSuccess) {
        toastr.success("Fiscal year updated successfully");
      }
      break;
    case ActionKeys.REQUEST_MAILING_ADDRESS:
      state = {
        ...state,
        isError: false,
        isSuccess: true,
        isFetching: {
          ...isFetching,
          MAILING_ADDRESS: true
        },
        isFetched: {
          ...isFetched,
          MAILING_ADDRESS: false
        }
      };
      break;
    case ActionKeys.RECEIVE_MAILING_ADDRESS:
      state = {
        ...state,
        ...action,
        isFetching: {
          ...isFetching,
          MAILING_ADDRESS: false
        },
        isFetched: {
          ...isFetched,
          MAILING_ADDRESS: true
        }
      };
      break;
    case ActionKeys.UPDATE_MAILING_ADDRESS:
      state = {
        ...state,
        ...action,
        isUpdating: {
          ...isUpdating,
          MAILING_ADDRESS: true
        }
      };
      if (action.isSuccess) {
        toastr.success("Mailing Address updated successfully");
      }
      break;
    case ActionKeys.REQUEST_CHAPTER_RANGES:
      state = {
        ...state,
        isError: false,
        isSuccess: true,
        isFetching: {
          ...isFetching,
          CHAPTER_RANGES: true
        },
        isFetched: {
          ...isFetched,
          CHAPTER_RANGES: false
        }
      };
      break;
    case ActionKeys.RECEIVE_CHAPTER_RANGES:
      state = {
        ...state,
        ...action,
        isFetching: {
          ...isFetching,
          CHAPTER_RANGES: false
        },
        isFetched: {
          ...isFetched,
          CHAPTER_RANGES: true
        }
      };
      break;
    case ActionKeys.UPDATE_CHAPTER_RANGES:
      state = {
        ...state,
        ...action,
        isUpdating: {
          ...isUpdating,
          CHAPTER_RANGES: true
        }
      };
      if (action.isSuccess) {
        toastr.success("Chapter ranges updated successfully");
      }
      break;
    case ActionKeys.REQUEST_MEMBER_COUNTS:
      state = {
        ...state,
        isError: false,
        isSuccess: true,
        isFetching: {
          ...isFetching,
          MEMBER_COUNTS: true
        },
        isFetched: {
          ...isFetched,
          MEMBER_COUNTS: false
        }
      };
      break;
    case ActionKeys.RECEIVE_MEMBER_COUNTS:
      state = {
        ...state,
        ...action,
        isFetching: {
          ...isFetching,
          MEMBER_COUNTS: false
        },
        isFetched: {
          ...isFetched,
          MEMBER_COUNTS: true
        }
      };
      break;
    case ActionKeys.CREATE_MEMBER_COUNT:
      state = {
        ...state,
        ...action
      };
      if (action.isSuccess) {
        toastr.success("Created chapter member count successfully");
      }
      break;
    case ActionKeys.UPDATE_MEMBER_COUNT:
      state = {
        ...state,
        ...action
      };
      if (action.isSuccess) {
        toastr.success("Updated chapter member count successfully");
      }
      break;
    case ActionKeys.REQUEST_CHAPTER_LIST:
      state = {
        ...state,
        activeChapter: null,
        isError: false,
        isSuccess: true,
        isFetching: {
          ...isFetching,
          CHAPTER_LIST: true
        },
        isFetched: {
          ...isFetched,
          CHAPTER_LIST: false
        }
      };
      break;
    case ActionKeys.RECEIVE_CHAPTER_LIST:
      state = {
        ...state,
        ...action,
        isFetching: {
          ...isFetching,
          CHAPTER_LIST: false
        },
        isFetched: {
          ...isFetched,
          CHAPTER_LIST: true
        }
      };
      break;
    case ActionKeys.REQUEST_CHAPTER:
      state = {
        ...state,
        activeChapter: null,
        isError: false,
        isSuccess: true,
        isFetching: {
          ...isFetching,
          CHAPTER: true
        },
        isFetched: {
          ...isFetched,
          CHAPTER: false
        }
      };
      break;
    case ActionKeys.RECEIVE_CHAPTER:
      state = {
        ...state,
        ...action,
        isFetching: {
          ...isFetching,
          CHAPTER: false
        },
        isFetched: {
          ...isFetched,
          CHAPTER: true
        }
      };
      break;

    case ActionKeys.REQUEST_CHAPTER_BUDGETS:
      state = {
        ...state,
        isError: false,
        isSuccess: true,
        isFetching: {
          ...isFetching,
          CHAPTER_BUDGETS: true
        },
        isFetched: {
          ...isFetched,
          CHAPTER_BUDGETS: false
        }
      };
      break;
    case ActionKeys.RECEIVE_CHAPTER_BUDGETS:
      state = {
        ...state,
        ...action,
        isFetching: {
          ...isFetching,
          CHAPTER_BUDGETS: false
        },
        isFetched: {
          ...isFetched,
          CHAPTER_BUDGETS: true
        }
      };
      break;
    case ActionKeys.REQUEST_CHAPTER_BUDGET:
      state = {
        ...state,
        isError: false,
        isSuccess: true,
        isFetching: {
          ...isFetching,
          CHAPTER_BUDGET: true
        },
        isFetched: {
          ...isFetched,
          CHAPTER_BUDGET: false
        }
      };
      break;
    case ActionKeys.RECEIVE_CHAPTER_BUDGET:
      state = {
        ...state,
        ...action,
        isFetching: {
          ...isFetching,
          CHAPTER_BUDGET: false
        },
        isFetched: {
          ...isFetched,
          CHAPTER_BUDGET: true
        }
      };
      break;
    case ActionKeys.CREATE_CHAPTER_BUDGET_STARTED:
    case ActionKeys.UPDATE_CHAPTER_BUDGET_STARTED:
      state = {
        ...state,
        ...action,
        isSuccess: true,
        isUpdating: {
          ...isUpdating,
          CHAPTER_BUDGET: true
        }
      };
      break;
    case ActionKeys.CREATE_CHAPTER_BUDGET_FINISHED:
    case ActionKeys.UPDATE_CHAPTER_BUDGET_FINISHED:
      state = {
        ...state,
        ...action,
        isUpdating: {
          ...isUpdating,
          CHAPTER_BUDGET: false
        },
        isFetched: {
          ...isFetched,
          CHAPTER_BUDGETS: false
        }
      };
      break;
    case ActionKeys.UPDATE_CHAPTER_BUDGET_FILE_STARTED:
      state = {
        ...state,
        ...action,
        isSuccess: true,
        isUpdating: {
          ...isUpdating,
          CHAPTER_BUDGET_FILE: true
        }
      };
      break;
    case ActionKeys.UPDATE_CHAPTER_BUDGET_FILE_FINISHED:
      state = {
        ...state,
        ...action,
        isUpdating: {
          ...isUpdating,
          CHAPTER_BUDGET_FILE: false
        },
        isFetched: {
          ...isFetched,
          CHAPTER_BUDGETS: false
        }
      };
      break;
    case ActionKeys.REQUEST_CHAPTER_SUMMARY_REPORT:
      state = {
        ...state,
        isError: false,
        isSuccess: true,
        isFetching: {
          ...isFetching,
          CHAPTER_SUMMARY: true
        },
        isFetched: {
          ...isFetched,
          CHAPTER_SUMMARY: false
        }
      };
      break;
    case ActionKeys.RECEIVE_CHAPTER_SUMMARY_REPORT:
      state = {
        ...state,
        ...action,
        isFetching: {
          ...isFetching,
          CHAPTER_SUMMARY: false
        },
        isFetched: {
          ...isFetched,
          CHAPTER_SUMMARY: true
        }
      };
      break;
    case ActionKeys.REQUEST_CHAPTER_FINANCIAL_REPORT:
      state = {
        ...state,
        isError: false,
        isSuccess: true,
        isFetching: {
          ...isFetching,
          CHAPTER_FINANCIALS: true
        },
        isFetched: {
          ...isFetched,
          CHAPTER_FINANCIALS: false
        }
      };
      break;
    case ActionKeys.REQUEST_CHAPTER_MEMBER_COUNT_TEMPLATE:
      state = {
        ...state,
        isError: false,
        isSuccess: true,
        isFetching: {
          ...isFetching,
          CHAPTER_FINANCIALS: true
        },
        isFetched: {
          ...isFetched,
          CHAPTER_FINANCIALS: false
        }
      };
      break;
    case ActionKeys.RECEIVE_CHAPTER_FINANCIAL_REPORT:
      state = {
        ...state,
        ...action,
        isFetching: {
          ...isFetching,
          CHAPTER_FINANCIALS: false
        },
        isFetched: {
          ...isFetched,
          CHAPTER_FINANCIALS: true
        }
      };
      break;
    case ActionKeys.UPLOAD_MEMBER_COUNTS:
      state = {
        ...state,
        ...action,
        isUploadSuccess: false,
        isError: false,
        isFetching: {
          ...isFetching,
          CHAPTER_FINANCIALS: false
        },
        isFetched: {
          ...isFetched,
          CHAPTER_FINANCIALS: true
        }
      };
      break;
    case ActionKeys.UPLOADED_MEMBER_COUNTS:
      state = {
        ...state,
        ...action,
        isUploadSuccess: action.isSuccess,
        isError: action.isError,
        errorMessage: action.errorMessage,
        message: action.message,
        isFetching: {
          ...isFetching,
          CHAPTER_FINANCIALS: false
        },
        isFetched: {
          ...isFetched,
          CHAPTER_FINANCIALS: true
        }
      };
      break;
    case ActionKeys.RECEIVE_CHAPTER_MEMBER_COUNT_TEMPLATE:
      state = {
        ...state,
        ...action,
        isFetching: {
          ...isFetching,
          CHAPTER_FINANCIALS: false
        },
        isFetched: {
          ...isFetched,
          CHAPTER_FINANCIALS: true
        }
      };
      break;
    case ActionKeys.REQUEST_CHAPTER_FINANCIALS:
      state = {
        ...state,
        activeChapterFinancial: null,
        isError: false,
        isSuccess: true,
        isFetching: {
          ...isFetching,
          CHAPTER_FINANCIALS: true
        },
        isFetched: {
          ...isFetched,
          CHAPTER_FINANCIALS: false
        }
      };
      break;
    case ActionKeys.RECEIVE_CHAPTER_FINANCIALS:
      state = {
        ...state,
        ...action,
        isFetching: {
          ...isFetching,
          CHAPTER_FINANCIALS: false
        },
        isFetched: {
          ...isFetched,
          CHAPTER_FINANCIALS: true
        }
      };
      break;
    case ActionKeys.REQUEST_GLOBAL_ANALYSIS_REPORTS:
      state = {
        ...state,
        isError: false,
        isSuccess: true,
        isFetching: {
          ...isFetching,
          GLOBAL_ANALYSIS_REPORTS: true
        },
        isFetched: {
          ...isFetched,
          GLOBAL_ANALYSIS_REPORTS: false
        }
      };
      break;
    case ActionKeys.RECEIVE_GLOBAL_ANALYSIS_REPORTS:
      state = {
        ...state,
        ...action,
        isFetching: {
          ...isFetching,
          GLOBAL_ANALYSIS_REPORTS: false
        },
        isFetched: {
          ...isFetched,
          GLOBAL_ANALYSIS_REPORTS: true
        }
      };
      break;
    case ActionKeys.REQUEST_CHAPTER_ANALYSIS_REPORTS:
      state = {
        ...state,
        isError: false,
        isSuccess: true,
        isFetching: {
          ...isFetching,
          CHAPTER_ANALYSIS_REPORTS: true
        },
        isFetched: {
          ...isFetched,
          CHAPTER_ANALYSIS_REPORTS: false
        }
      };
      break;
    case ActionKeys.RECEIVE_CHAPTER_ANALYSIS_REPORTS:
      state = {
        ...state,
        ...action,
        isFetching: {
          ...isFetching,
          CHAPTER_ANALYSIS_REPORTS: false
        },
        isFetched: {
          ...isFetched,
          CHAPTER_ANALYSIS_REPORTS: true
        }
      };
      break;
    case ActionKeys.REQUEST_CHAPTER_FINANCIALS_DEFAULTS:
      state = {
        ...state,
        isError: false,
        isSuccess: true,
        isFetching: {
          ...isFetching,
          CHAPTER_FINANCIALS_DEFAULTS: true
        },
        isFetched: {
          ...isFetched,
          CHAPTER_FINANCIALS_DEFAULTS: false
        }
      };
      break;
    case ActionKeys.RECEIVE_CHAPTER_FINANCIALS_DEFAULTS:
      state = {
        ...state,
        ...action,
        isFetching: {
          ...isFetching,
          CHAPTER_FINANCIALS_DEFAULTS: false
        },
        isFetched: {
          ...isFetched,
          CHAPTER_FINANCIALS_DEFAULTS: true
        }
      };
      break;
    case ActionKeys.REQUEST_CHAPTER_FINANCIAL:
      state = {
        ...state,
        activeChapterFinancial: null,
        isError: false,
        isSuccess: true,
        isFetching: {
          ...isFetching,
          CHAPTER_FINANCIAL: true
        },
        isFetched: {
          ...isFetched,
          CHAPTER_FINANCIAL: false
        }
      };
      break;
    case ActionKeys.RECEIVE_CHAPTER_FINANCIAL:
      state = {
        ...state,
        ...action,
        isFetching: {
          ...isFetching,
          CHAPTER_FINANCIAL: false
        },
        isFetched: {
          ...isFetched,
          CHAPTER_FINANCIAL: true
        }
      };
      break;
    case ActionKeys.REQUEST_REPORT_ITEM_TYPES:
      state = {
        ...state,
        ...action,
        isFetching: {
          ...isFetching,
          REPORT_ITEM_TYPES: true
        },
        isFetched: {
          ...isFetched,
          REPORT_ITEM_TYPES: false
        }
      };
      break;
    case ActionKeys.RECEIVE_REPORT_ITEM_TYPES:
      state = {
        ...state,
        ...action,
        isFetching: {
          ...isFetching,
          REPORT_ITEM_TYPES: false
        },
        isFetched: {
          ...isFetched,
          REPORT_ITEM_TYPES: true
        }
      };
      break;
    case ActionKeys.REQUEST_REPORT_ITEM_SUB_TYPES:
      state = {
        ...state,
        ...action,
        isFetching: {
          ...isFetching,
          REPORT_ITEM_SUB_TYPES: true
        },
        isFetched: {
          ...isFetched,
          REPORT_ITEM_SUB_TYPES: false
        }
      };
      break;
    case ActionKeys.RECEIVE_REPORT_ITEM_SUB_TYPES:
      state = {
        ...state,
        ...action,
        isFetching: {
          ...isFetching,
          REPORT_ITEM_SUB_TYPES: false
        },
        isFetched: {
          ...isFetched,
          REPORT_ITEM_SUB_TYPES: true
        }
      };
      break;
    case ActionKeys.UPDATE_REPORT_ADMIN_NOTES_STARTED:
      state = {
        ...state,
        ...action,
        isSuccess: true,
        isUpdating: {
          ...isUpdating,
          REPORT_ADMIN_NOTES: true
        }
      };
      break;
    case ActionKeys.UPDATE_REPORT_ADMIN_NOTES_FINISHED:
      state = {
        ...state,
        ...action,
        isUpdating: {
          ...isUpdating,
          REPORT_ADMIN_NOTES: false
        },
        isFetched: {
          ...isFetched,
          REPORT_ADMIN_NOTES: false
        }
      };
      if (action.isSuccess) {
        toastr.success("Updated report admin notes successfully");
      }
      break;
    case ActionKeys.CREATE_REPORT_ITEM_STARTED:
    case ActionKeys.UPDATE_REPORT_ITEM_STARTED:
    case ActionKeys.REMOVE_REPORT_ITEM_STARTED:
    case ActionKeys.UPDATE_REPORT_ITEMS_STARTED:
    case ActionKeys.INITIAL_REPORT_ITEMS_STARTED:
      state = {
        ...state,
        ...action,
        isSuccess: true,
        isUpdating: {
          ...isUpdating,
          REPORT_ITEM: true
        }
      };
      break;
    case ActionKeys.CREATE_REPORT_ITEM_FINISHED:
    case ActionKeys.UPDATE_REPORT_ITEM_FINISHED:
    case ActionKeys.UPDATE_REPORT_ITEMS_FINISHED:
    case ActionKeys.INITIAL_REPORT_ITEMS_FINISHED:
      state = {
        ...state,
        ...action,
        isUpdating: {
          ...isUpdating,
          REPORT_ITEM: false
        },
        isFetched: {
          ...isFetched,
          REPORT_ITEM: false
        }
      };
      if (action.isSuccess) {
        toastr.success("Updated report successfully");
      }
      break;
    case ActionKeys.UPDATE_REPORT_W2_STARTED:
      state = {
        ...state,
        ...action,
        isSuccess: true,
        isUpdating: {
          ...isUpdating,
          REPORT_W2: true
        }
      };
      break;
    case ActionKeys.UPDATE_REPORT_W2_FINISHED:
      state = {
        ...state,
        ...action,
        isUpdating: {
          ...isUpdating,
          REPORT_W2: false
        },
        isFetched: {
          ...isFetched,
          REPORT_W2: false
        }
      };
      if (action.isSuccess) {
        toastr.success("Updated report W2/1099 successfully");
      }
      break;
    case ActionKeys.UPDATE_REPORT_VOTING_COUNT_STARTED:
      state = {
        ...state,
        ...action,
        isSuccess: true,
        isUpdating: {
          ...isUpdating,
          REPORT_VOTING_COUNT: true
        }
      };
      break;
    case ActionKeys.UPDATE_REPORT_VOTING_COUNT_FINISHED:
      state = {
        ...state,
        ...action,
        isUpdating: {
          ...isUpdating,
          REPORT_VOTING_COUNT: false
        },
        isFetched: {
          ...isFetched,
          REPORT_VOTING_COUNT: false
        }
      };
      if (action.isSuccess) {
        toastr.success("Updated voting information successfully");
      }
      break;
    case ActionKeys.CREATE_FINANCIAL_ACCOUNT_STARTED:
      state = {
        ...state,
        ...action,
        isSuccess: true,
        isUpdating: {
          ...isUpdating,
          FINANCIAL_ACCOUNT: true
        }
      };
      break;
    case ActionKeys.CREATE_FINANCIAL_ACCOUNT_FINISHED:
      state = {
        ...state,
        ...action,
        isUpdating: {
          ...isUpdating,
          FINANCIAL_ACCOUNT: false
        },
        isFetched: {
          ...isFetched,
          FINANCIAL_ACCOUNT: false
        }
      };
      if (action.isSuccess) {
        toastr.success("Created financial account successfully");
      }
      break;
    case ActionKeys.UPDATE_FINANCIAL_ACCOUNT_STARTED:
      state = {
        ...state,
        ...action,
        isSuccess: true,
        isUpdating: {
          ...isUpdating,
          FINANCIAL_ACCOUNT: true
        }
      };
      break;
    case ActionKeys.UPDATE_FINANCIAL_ACCOUNT_FINISHED:
      state = {
        ...state,
        ...action,
        isUpdating: {
          ...isUpdating,
          FINANCIAL_ACCOUNT: false
        },
        isFetched: {
          ...isFetched,
          FINANCIAL_ACCOUNT: false
        }
      };
      if (action.isSuccess) {
        toastr.success("Updated financial account successfully");
      }
      break;
    case ActionKeys.REMOVE_FINANCIAL_ACCOUNT_STARTED:
      state = {
        ...state,
        ...action,
        isSuccess: true,
        isUpdating: {
          ...isUpdating,
          FINANCIAL_ACCOUNT: true
        }
      };
      break;
    case ActionKeys.REMOVE_FINANCIAL_ACCOUNT_FINISHED:
      state = {
        ...state,
        ...action,
        isUpdating: {
          ...isUpdating,
          FINANCIAL_ACCOUNT: false
        },
        isFetched: {
          ...isFetched,
          FINANCIAL_ACCOUNT: false
        }
      };
      if (action.isSuccess) {
        toastr.success("Removed financial account successfully");
      }
      break;
    case ActionKeys.SUBMIT_CHAPTER_FINANCIAL_STARTED:
      state = {
        ...state,
        ...action,
        isSuccess: true,
        isUpdating: {
          ...isUpdating,
          SUBMIT_CHAPTER_FINANCIAL: true
        }
      };
      break;
    case ActionKeys.SUBMIT_CHAPTER_FINANCIAL_FINISHED:
      state = {
        ...state,
        ...action,
        isUpdating: {
          ...isUpdating,
          SUBMIT_CHAPTER_FINANCIAL: false
        },
        isFetched: {
          ...isFetched,
          SUBMIT_CHAPTER_FINANCIAL: false
        }
      };
      if (action.isSuccess) {
        toastr.success("The chapter financial is submitted successfully.");
      }
      break;
    case ActionKeys.ACCEPT_CHAPTER_FINANCIAL_STARTED:
      state = {
        ...state,
        ...action,
        isSuccess: true
      };
      break;
    case ActionKeys.ACCEPT_CHAPTER_FINANCIAL_FINISHED:
      state = {
        ...state,
        ...action
      };
      if (action.isSuccess) {
        toastr.success("Accepted chapter financial successfully");
      }
      break;
    case ActionKeys.REJECT_CHAPTER_FINANCIAL_STARTED:
      state = {
        ...state,
        ...action,
        isSuccess: true
      };
      break;
    case ActionKeys.REJECT_CHAPTER_FINANCIAL_FINISHED:
      state = {
        ...state,
        ...action
      };
      if (action.isSuccess) {
        toastr.success("Rejected chapter financial successfully");
      }
      break;
    default:
      return { ...state };
  }

  if (state.isError && state.errorMessage && state.errorMessage !== "") {
    toastr.error(state.errorMessage);
  } else if (!state.isSuccess) {
    toastr.error("Error while calling the api endpoint");
  }

  return { ...state };
}
